<div class="segmented-radio" role="radiogroup">
  @for (option of options(); track option.value) {
    <div class="segment">
      <input
        class="segment-input"
        type="radio"
        [id]="idPrefix() + '-' + option.value"
        [name]="name()"
        [value]="option.value"
        [checked]="value() === option.value"
        (change)="value.set(option.value)"
      />

      <label
        class="segment-label"
        [for]="idPrefix() + '-' + option.value"
        [class.selected]="value() === option.value"
      >
        {{ option.label }}
      </label>
    </div>
  }
</div>
